/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormDraft } from './FormDraft';
import type { FormField } from './FormField';
export type Form = {
    status: Form.status;
    draftUpdatedAt?: string | null;
    draft?: FormDraft | null;
    id: number;
    name: string;
    description: string | null;
    expiresAfterDays: number | null;
    reminderAfterDays: number | null;
    fields: Array<FormField>;
};
export namespace Form {
    export enum status {
        DRAFT = 'draft',
        ACTIVE = 'active',
    }
}

